import { useLocation } from 'react-router-dom';

/**
 *
 * @param {@memberof useLocation} userLocation - instance of useLocation
 * @returns {boolean}
 */

function useWasFromWallet() {
	const location = useLocation();

	const { state } = location;

	return state?.fromWallet;
}

export default useWasFromWallet;
